import React from 'react';
import ProfileWrapper from './ProfileWrapper';
import BasicProfileInformation from './BasicProfileInformation';
import MapsSymbol from '../../assets/img/maps-symbol.png';
import HospitalIcon from '../../assets/img/hospital-icon.png';
import ClinicDepartmentsList from './ClinicDepartmentsList';
import DomainData from '../../assets/datasets/DomainData';
import config from '../../configuration';
import axios from 'axios';
import BedsIcon from '../../assets/img/bed-icon.png';
import LoadingSkeleton from '../misc/LoadingSkeleton';
import PrimaryButton from '../buttons/PrimaryButton';
import RecommendationButton from '../buttons/RecommendationButton';
import ShareButtons from '../misc/ShareButtons';
import LVRLangenfeld from './profiles/LVRLangenfeld';

const compareByRatings = (a, b) => {
  if (a.last_nom < b.last_nom) {
    return -1;
  }
  if (a.last_nom > b.last_nom) {
    return 1;
  }
  return 0;
};

const generateDepartmentInfos = (d, i, openDepartment) => {
  return {
    ...d,
    gotoDepartment: () => openDepartment(d.id)
  };
};

const generateDepartmentObject = (clinicObject) => {
  return clinicObject.departments.map((d, i) => ({
    name: d,
    id: clinicObject.department_ids[i],
    parentId: clinicObject.parent_ids[i]
  }));
};

const clinicSizeTextMapper = [
  <p key={0}>kleines Haus&nbsp;&nbsp;&nbsp;<span style={{ fontWeight: 800 }}>Ø -30%</span></p>,
  <p key={0}>mittelgroßes Haus&nbsp;&nbsp;&nbsp;<span style={{ fontWeight: 800 }}>Ø -10%</span></p>,
  <p key={0}>mittelgroßes Haus&nbsp;&nbsp;&nbsp;<span style={{ fontWeight: 800 }}>Ø +10%</span></p>,
  <p key={0}>großes Haus&nbsp;&nbsp;&nbsp;<span style={{ fontWeight: 800 }}>Ø +30%</span></p>,
  <p key={0}>sehr großes Haus&nbsp;&nbsp;&nbsp;<span style={{ fontWeight: 800 }}>Ø +50%</span></p>
];

const missingData = clinicObject => {
  if (
    !clinicObject.beds ||
    !clinicObject.departments
  ) return true;
  return false;
};

const clinicSizeMapper = (beds, cb = v => v) => {
  if (beds < 50) return cb(0);
  else if (beds < 150) return cb(1);
  else if (beds < 300) return cb(2);
  else if (beds < 500) return cb(3);
  else return cb(4);
};

const ClinicProfile = props => {
  // const [departments, setDepartments] = React.useState([]);
  const [loading, setLoading] = React.useState([]);
  const [stations, setStations] = React.useState([]);
  const [clinic, setClinic] = React.useState(props.clinicObject);

  React.useEffect(() => {
    // if searching for a specific subject_area, the clinic object only stores
    // one department.
    // In order to receive the other departments, we make a new request
    // to get the information for the specific clinic
    if (missingData(props.clinicObject)) {
      setLoading(true);
      axios.get(config.backendAddress + '/open/getClinics?id=' + props.clinicObject.id)
        .then(result => {
          const newClinicObject = result.data[0];
          setClinic({ ...newClinicObject, departments: generateDepartmentObject(newClinicObject) });
          setLoading(false);
        });
    } else {
      setClinic({ ...clinic, departments: generateDepartmentObject(props.clinicObject) });
      getStations(props.clinicObject.id);
      setLoading(false);
    }
  }, [props.clinicObject]);

  const getStations = id => {
    if (id) {
      axios.get(config.backendAddress + '/open/getStations?basic=true&clinicId=' + id)
        .then(result => {
          console.log(result.data);
          setStations(old => result.data);
        });
    }
  };

  return (
    <>
      <ProfileWrapper width={470} height={700} open={() => props.open(false)}>
        <BasicProfileInformation
          {...props}
          hideBackButton
          recommendationComponent={<></>}
          title={clinic.name}
          informationList={
            !missingData(clinic)
              ? [
                  {
                    icon: <img src={MapsSymbol} width={12} />,
                    info: <p>{Object.values(clinic.address).join(', ')}</p>
                  },
                  /* {
                      icon: <p style={{ fontWeight: '800', textAlign: 'center', marginLeft: 0 }}>€</p>,
                      info: <p style={{ textDecoration: 'underline' }}>2.394 € netto</p>
                    }, */
                  /* {
                      icon: <p style={{ fontWeight: '800', textAlign: 'center', marginLeft: 0 }}><i className={clinic.education_clinic ? 'fa fa-check' : 'fa fa-times'} /></p>,
                      info: <p>{clinic.education_clinic ? 'Akademisches Lehrkrankenhaus' : 'kein Lehrkrankenhaus'}</p>
                    }, */
                  {
                    icon: <img src={HospitalIcon} width={12} />,
                    info: <>{clinicSizeMapper(clinic.beds, (v) => clinicSizeTextMapper[v])}{/* <p>großes Haus&nbsp;&nbsp;&nbsp;<span style={{ fontWeight: 800 }}>Ø +40%</span></p> */}</>
                  },
                  {
                    icon: <img src={BedsIcon} width={12} />,
                    info: <p>{clinic.beds} Betten</p>
                  },
                  ...stations.filter(s => !s.name.indexOf(stations.map(s => s.name))).map(s => {
                    return {
                      icon: <i className='fa fa-check' />,
                      info: <p>{s.name}</p>
                    };
                  })
                ]
              : []
}
        />
        <RecommendationButton
          clinic={clinic}
        />
        {/* <ClinicRatings
          ratings={{
            einarbeitung: [],
            weiterbildung: [],
            arbeitszeiten: [],
            team: [],
            infrastruktur: [],
            sonstiges: []
          }}
        /> */}
        {/* the areas you have filtered for */}
        <div className='profile-body-wrapper' style={{ marginTop: 40 }}>
          {
          loading
            ? (
              <>
                <h2 style={{ fontWeight: 'bold' }}>Fachabteilungen</h2>
                <LoadingSkeleton style={{ marginTop: 50, marginLeft: 50 }} />
              </>
              )
            : (
              <>
                <h2 style={{ fontWeight: 'bold' }}>Fachabteilungen</h2>
                {
                clinic.departments.length > 0
                  ? (
                    <>
                      {/* the other areas */}
                      <div style={{ width: '100%', height: 1, marginTop: 20 }} />
                      <ClinicDepartmentsList
                        departments={
                          clinic.departments
                            .filter(d => !props.departmentFilter.includes(d))
                            .map((d, i) => generateDepartmentInfos(d, i, props.openDepartment))
                        }
                      />
                    </>
                    )
                  : (
                    <span style={{ color: 'grey' }}>keine Abteilungen abgespeichert...</span>
                    )
              }
                {/* {
                    stations.length > 0 && (
                      <>
                        <h2 style={{ fontWeight: 'bold' }}>Stationen</h2>
                        <table>
                          <tbody>
                            {
                              stations.map(station => {
                                return (
                                  <tr key={station.id}>
                                    <td>
                                      <i className='fa fa-check' />
                                    </td>
                                    <td style={{ paddingLeft: 15 }}>
                                      {station.name}
                                    </td>
                                  </tr>
                                );
                              })
                            }
                          </tbody>
                        </table>
                      </>
                    )
                  } */}

              </>
              )
        }
          {
          parseInt(clinic.id) === 12071 && (
            <>
              <br />
              <LVRLangenfeld />
            </>
          )
        }
          <br />
          <h6 style={{ fontWeight: 'bold' }}>Kennst du jemanden, der/die hier arbeitet?</h6>
          <ShareButtons
            title='Klinikbewertungen auf Felix Medicus'
            summary={'Schau mal hier: Ich habe die Bewertungen vom ' + clinic.name}
          />
        </div>
      </ProfileWrapper>
    </>
  );
};

export default ClinicProfile;
